<!-- Translated: skip -->
<template>
  <div class="component">
    <div class="flex">
      <div class="info" v-if="localResetPasswordSuccessMessage">
        <p>{{localResetPasswordSuccessMessage}}</p>
      </div>
    </div>
    <div>
    </div>
    <div class="flex" v-if="!loggedIn && !$route.query.admin">
      <div>
        <b>E-postadress</b>
        <input type="email" v-model="email" @keyup.enter="login" />
      </div>
      <div>
        <b>Lösenord</b>
        <input type="password" @keyup.enter="login" v-model="password" />
      </div>
      <div v-if="error">
        <p class="error-message">
          Uppgifterna stämde inte. Försök igen med ett annat lösenord eller beställ ett nytt lösenord nedan.</p>
      </div>
      <div class="center">
        <p class="spacer">&nbsp;</p>
        <button class="small" :disabled="loading" @click="login()">{{loading ? 'Loggar in...' : 'Logga in'}}</button>
      </div>
      <div class="center">
        <p class="spacer">&nbsp;</p>
        <router-link class="button white small underlined" :to="{ name: 'request reset password' }">Glömt lösenord</router-link>
        <router-link class="button white small underlined" :to="{ name: 'request new password' }">Har inget lösenord</router-link>
      </div>
    </div>

    <div class="flex" v-if="$route.query.admin && !adminUser">
      <div>
        <b>Admin-användare</b>
        <input type="text" v-model="email" @keyup.enter="loginAdmin" />
      </div>
      <div>
        <b>Lösenord</b>
        <input type="password" @keyup.enter="loginAdmin" v-model="password" />
      </div>
      <div v-if="error">
        <p class="error-message">
          Uppgifterna stämde inte. Försök igen med ett annat lösenord.</p>
      </div>
      <div class="center">
        <p class="spacer">&nbsp;</p>
        <button class="small" :disabled="loading" @click="loginAdmin()">{{loading ? 'Loggar in i admin...' : 'Logga in admin'}}</button>
      </div>
    </div>

    <div v-if="adminUser">
      <hr />
    </div>

    <div class="flex" v-if="adminUser">
      <div>
        <div class="center">
          <button class="small" @click="goToAdmin()">Gå till admin</button>
          <br /><br /><br /><br />
        </div>
      </div>
      <div>
        <p>Du är inloggad i admin</p>
        <div class="center">
          <button class="small white" @click="logoutAdmin()">Logga ut från admin</button>
        </div>
      </div>
    </div>

    <div class="flex" v-if="loggedIn">
      <div>
        <p>Du är inloggad</p>
        <div class="center">
          <button class="small" @click="logout()">Logga ut</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import API from '@/classes/API';

export default {
  props: {
  },
  components: {
  },
  data() {
    return {
      email: '',
      password: '',
      passwordShow: true,
      loading: false,
      error: false,
      localResetPasswordSuccessMessage: '',
    };
  },
  mounted() {
    this.localResetPasswordSuccessMessage = this.resetPasswordSuccessMessage;
    console.log(this.localResetPasswordSuccessMessage);
    this.updateResetPasswordSuccessMessage('');
  },
  updated() {
    this.updateResetPasswordSuccessMessage('');
  },
  computed: {
    ...mapGetters([
      'loggedIn',
      'resetPasswordSuccessMessage',
    ]),
    adminUser() {
      return localStorage.getItem('admin_user');
    },
  },
  methods: {
    ...mapMutations([
      'setUser',
      'updateResetPasswordSuccessMessage',
    ]),
    async login() {
      this.loading = true;
      const { success, token, user, isAdmin } = await API.post('/account/authenticate', {
        email: this.email,
        password: this.password,
      });

      if (success) {
        this.$store.state.user = user;
        this.$store.state.user.isAdmin = isAdmin;
        this.$store.state.user.token = token;

        this.setUser({
          token,
        });

        this.$emit('login', success);

        document.body.dispatchEvent(new CustomEvent('bookinguserstatechanged', { detail: true }));
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    async loginAdmin() {
      this.loading = true;
      const { success } = await API.post('/account/authenticate-admin', {
        email: this.email,
        password: this.password,
      });

      if (success) {
        localStorage.setItem('admin_user', `${this.email}:${this.password}`);
        this.$emit('login', success);
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    async logout() {
      this.loading = true;
      const success = await API.get('/account/deauthenticate');
      this.setUser({
        token: null,
      });
      if (success) {
        this.$emit('logout', success);

        document.body.dispatchEvent(new CustomEvent('bookinguserstatechanged', { detail: false }));
      }
      this.loading = false;
    },
    logoutAdmin() {
      this.loading = true;
      localStorage.setItem('admin_user', '');
      this.$emit('logout', true);
      this.loading = false;
    },
    goToAdmin() {
      this.$router.push('/admin');
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.info
  info-box()
  max-width 400px
  margin-bottom 20px

.component
  text-align: center

b
  display block
  uppercase()
  margin-top 10px

p.spacer
  margin-bottom 0
  margin-top 0
  font-size 10px

.flex
  //display flex
  display inline-block
  text-align left

.error-message, .success-message
  max-width 260px
  margin-top 10px
  margin-bottom 0


input
  input()
  min-width 260px
  max-width 260px
</style>



// WEBPACK FOOTER //
// Login.vue?2d3b865e